import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';

const requests = {
	unlinkArtistProfile: (artistId: number) =>
		requestWrapper.delete(endpoints.unlinkArtistProfile(artistId)),
};

export default requests;
